import Anchor from "atoms/anchors/anchor";
import React from "react";
import logo from "assets/images/nfpa-link-color.png";
import { siteMap } from "internal-sitemap";

const BASE_CLASS = "c-printable__demoHeader";

const DemoPrintHeader = () => {
    return (
        <header className={`${BASE_CLASS}__header`}>
            <Anchor
                to={siteMap.home}
                ariaLabel="Home"
                cssClassName={`${BASE_CLASS}__logoWrapper`}>
                <img src={logo} alt="Home" className={`${BASE_CLASS}__logo`} />
            </Anchor>
        </header>
    );
};

export default DemoPrintHeader;
